import { useEffect } from 'react';
import { useAppDispatch } from '../redux/hooks';
import { setIsSSOEnabled } from '../redux/slices/auth';
import { resetToInitial } from '../redux/globalActions';
import { isSSOEnabled } from '../constants';
export var useIsSSOEnabled = function () {
    var dispatch = useAppDispatch();
    useEffect(function () {
        if (!isSSOEnabled) {
            dispatch(resetToInitial());
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
        }
        dispatch(setIsSSOEnabled(isSSOEnabled));
    }, []);
};
